import TextStyle from '../../../../../../styles/text';
import ColorStyle from '../../../../../../styles/colors';

const bodyStyle = {
    padding: 0,
    maxHeight: 500,
};
const actionsContainer = {
    padding: '0px 30px 30px 0px',
};

export default {
    input_hint: {
        ...TextStyle.text_lg_hint,
    },
    input_floating: {
        ...TextStyle.big_text_md,
    },
    input: {
        ...TextStyle.text_lg,
    },
    title: {
        ...TextStyle.modal_title,
        borderBottom: 0,
        padding: 16,
        borderBottom: '1px solid #ddd',
    },
    actionsContainer,
    title_text: {
        ...TextStyle.big_text_md,
        marginBottom: 6,
        marginTop: 30,
    },
    title_text2: {
        ...TextStyle.big_text_md,
        marginTop: 20,
    },
    text: {
        ...TextStyle.text_xs,
    },
    text_link: {
        ...TextStyle.link_md,
    },
    text_medium: {
        ...TextStyle.text_md,
    },
    bodyStyle,

    contentStyleSmall: {},
    contentStyleNormal: {},

    contentStyleSmallError: {
        backgroundColor: '#FBDEE1',
        borderTop: '1px solid #F0485C',
        paddingTop: 20,
        maxWidth: 360,
    },
    clearIcon: {
        color: ColorStyle.fm_icon,
        fontSize: 13,
        cursor: 'pointer',
        float: 'right',
    },

    bodyStyleShare: {
        ...bodyStyle,
        background: '#f0f0f0',
        paddingBottom: 16,
    },
    actionsContainerShare: {
        ...actionsContainer,
        background: '#white',
        padding: 16,
        borderTop: '1px solid #ddd',
    },
    linkText: {
        ...TextStyle.text_md,
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
    },
};
